export const processRecursive = (list, action) => {
	return new Promise((resolve) => {
		if (list.length > 0) {
			let fk = list.shift();
			action(fk).then((success) => {
				if (!success) return resolve(false);
				return resolve(processRecursive(list, action));
			});
		} else {
			return resolve(true);
		}
	});
};
